export default __webpack_public_path__ + "images/ae913c09cb9a7fb621af289d5257226d-maestro@2x.png";